import React, { useEffect, useRef, useState } from "react";
import * as HAN from '../style/StyleComponentHeaderAndNav';
import headerMenuIcon from '../assets/icons/menu.svg';
import Nav from "./Nav";
import { useLocation, useNavigate } from "react-router-dom";
import shoppingBagIcon from "../assets/icons/shopping_bag.svg";
import theme from "../style/theme";
import { PROCESS_MANUAL_URL } from "../Variable";
// import { get_select_reservation_indicator } from "../Axios";
// import { useSelector } from "react-redux";
// import { RootState } from "../redux/Store";
// import Indicator from "./Utility/Indicator";

const opacity_40 = theme.colors.opacity_40;

// interface IndicatorObject {
//     construction_reservation_ID : number;
//     construction_reservation_name : string;
//     construction_reservation_reservationTime : string;
//     construction_reservation_time_name : string;
//     construction_reservation_progress : number;
//     construction_reservation_progress_name : string;
//     today : string;
//     date_diff : number;
// }

const Header: React.FC = () => {
    const navigate = useNavigate();
    const locationHook = useLocation();
    const [currentLastUrl, setCurrentLastUrl] = useState<string | null>('');

    // const customerData = useSelector((state: RootState) => state.customerData);
    const [navModal, setNavModal] = useState<boolean>(false);
    const [innerWidth, setInnerWidth] = useState<number>(0);
    // const [indicatorList, setIndicatorList] = useState<IndicatorObject[]>([]);

    const navBackRef: React.RefObject<HTMLDivElement> = useRef(null);
    const navRef: React.RefObject<HTMLDivElement> = useRef(null);


    useEffect(() => {
        const splitUrl = locationHook?.pathname?.split('/') ?? null;
        const location: string | null = splitUrl?.length > 1 ? splitUrl[splitUrl.length -1] : null;
        setCurrentLastUrl(location);
    }, [currentLastUrl, locationHook]);

    // useEffect(() => {
    //     if(!customerData.customer_ID) return;
    //     get_select_reservation_indicator(customerData.customer_ID).then(result => {
    //         setIndicatorList(result);
    //     })
    // }, [currentLastUrl, customerData.customer_ID]);

    // 가로 너비 1200px 이하일 때 nav 토글형식으로 전환
    useEffect(() => {
        const resizeListener = () => {
            setInnerWidth(window.innerWidth);
            if(innerWidth > 1200) {
                setNavModal(false);
            }
        };
        window.addEventListener('resize', resizeListener);

        return (() => {
            window.removeEventListener('resize', resizeListener);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        if(navModal && navRef.current && navBackRef.current) {
            navBackRef.current.style.background = opacity_40;
            navRef.current.classList.add('nav-menu-slide-on');
            document.body.classList.add('on-modal-back');
        }
    }, [navModal]);

    // 모달창 배경화면 클릭했을 때 모달창 꺼짐
    const clickOffNavModal = (e: React.MouseEvent<HTMLDivElement>) => {
        if(e.target !== e.currentTarget) {
            return;
        }
        offNavModal();
    };

    // 모달창 끄는 함수
    const offNavModal = () => {
        if(navModal && navRef.current && navBackRef.current) {
            navBackRef.current.style.background = 'transparent';
            navRef.current.classList.remove('nav-menu-slide-on');
            navRef.current.classList.add('nav-menu-slide-off');
            document.body.classList.remove('on-modal-back');
        };
        setTimeout(() => {
            setNavModal(false);
        }, 280);
    };

    // 로고 클릭시 메인화면으로
    const goMain = () => {
        navigate('/main');
        offNavModal();
    }

    const handleDownload = () => {
        const url = PROCESS_MANUAL_URL;
      
        const newWindow = window.open(url, '_blank');
        
        if (newWindow) {
          newWindow.focus();
        }
      };

    return (
        <div className="fixed w-[100%] z-[199]">
            <HAN.HeaderContainer>
                <div className="header-left-box">
                    <div onClick={() => {if(!navModal) {setNavModal(true);} else {offNavModal();}}} className="header-menu-icon">
                        <img src={headerMenuIcon} alt="" />
                    </div>
                    <div onClick={() => {goMain()}} className="header-logo-box">
                        <div className="header-logo-img">
                            <img src={require('../assets/images/ablack_logo_w.png')} alt="" width="100%" />
                        </div>
                        <div className="header-logo-text">
                            <span>B2B 통합관리 시스템</span>
                        </div>
                        <div className="header-manual-button">
                            &nbsp;|&nbsp;
                            <button onClick={handleDownload}>
                                시공 프로세스 메뉴얼
                            </button>
                        </div>
                    </div>
                </div>
                <div className="header-right-box">
                    {/* <HAN.IndicatorBox>
                        <Indicator indicatorList={indicatorList} />
                    </HAN.IndicatorBox> */}
                    <div onClick={() => {
                        navigate('/shopping_bag');
                    }}>
                        <img src={shoppingBagIcon} alt="" />
                    </div>
                </div>
            </HAN.HeaderContainer>
            {navModal &&
                <>
                <HAN.ModalBackground ref={navBackRef} onClick={clickOffNavModal}></HAN.ModalBackground>
                <HAN.ModalNavigation ref={navRef}>
                    <Nav offNavModal={offNavModal} />
                </HAN.ModalNavigation>
                </>
            }
        </div>
    )
};

export default Header;